import { useQuery } from '@tanstack/react-query';
import { SettingsApi } from '@/features/settings/api';

export const useGetSettings = () => {
  const { isLoading, isError, data, error, refetch } = useQuery({
    queryKey: ['settingsApi.getSettings'],
    queryFn: SettingsApi.getSettings,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error,
    refetch
  };
};
